import Dexie, { Table } from 'dexie';

export interface ITermsAcceptance {
    id?: number;
    userId: string;
    auctionId: number;
    accepted: boolean;
}

export class BiddifyDexie extends Dexie {
    termsAcceptances!: Table<ITermsAcceptance>;

    constructor() {
        super('biddify-db');
        this.version(1).stores({
            termsAcceptances: '++id, &[userId+auctionId]'
        });
    }
}

export const db = new BiddifyDexie(); 